import { useMemo } from "react"

import { isAllBooksId } from "@/lib/all-books"
import { useFetchBooks } from "@/hooks/api/books"
import { useBookId } from "@/hooks/use-book-id"

export function useBookSelectorVisibility() {
  const bookId = useBookId()
  const { data, isLoading } = useFetchBooks()

  const shouldShow = useMemo(() => {
    return isAllBooksId(bookId)
  }, [bookId])

  return {
    shouldShow,
    books: data?.books ?? [],
    isLoading,
  }
}
